import React from "react";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import { introComponents } from "./markdownComponents";

type HeadingAndSubtitleProps = {
    heading: string;
    subtitle: string;
};

const HeadingAndSubtitle: React.FC<HeadingAndSubtitleProps> = ({ heading, subtitle }) => {
    if (!heading && !subtitle) return null;
    return (
        <div className="space-y-4">
            {heading && (
                // Prima era testo grezzo: markdown (link, grassetto, elenchi)
                // non veniva interpretato. Ora è coerente con heading_1..5.
                <h2 className="text-white font-bold text-xl md:text-2xl uppercase tracking-tight leading-snug">
                    <ReactMarkdown
                        remarkPlugins={[remarkBreaks]}
                        components={introComponents}
                    >
                        {heading?.replace(/\\n/g, "\n")}
                    </ReactMarkdown>
                </h2>
            )}
            {subtitle && (
                // <div> e non <p>: un <ul> dentro un <p> è HTML non valido e
                // il browser chiuderebbe il paragrafo, rompendo il layout.
                <div className="text-white text-opacity-80 text-base md:text-lg leading-loose whitespace-pre-line">
                    <ReactMarkdown
                        remarkPlugins={[remarkBreaks]}
                        components={introComponents}
                    >
                        {subtitle?.replace(/\\n/g, "\n")}
                    </ReactMarkdown>
                </div>
            )}
        </div>
    );
};

export default HeadingAndSubtitle;
